import PropTypes from "prop-types";
import React from "react";
import { ChevronLeft } from "react-ikonate";
import SpinningIcon from "shared/SpinningIcon";
import styles from "./DisclosurePublishingBar.module.css";

export const DisclosurePublishingState = {
  create: "create",
  editPending: "edit-pending",
  editSaved: "edit-saved",
};

export function DisclosurePublishingBar({
  state,
  isPublishing,
  publishDisabled,
  onBack,
  onHistory,
  onPublish,
}) {
  const isCreate = state === DisclosurePublishingState.create;
  const isSaved = state === DisclosurePublishingState.editSaved;
  const publishLabel = isCreate ? "Push Live" : "Push Revisions";

  return (
    <div className={styles.bar}>
      <button type="button" className={styles.backButton} onClick={onBack}>
        <ChevronLeft size={24} />
        <span>Back</span>
      </button>

      <div className={styles.actions}>
        {isPublishing && (
          <span className={styles.savingBadge} role="status">
            <SpinningIcon size={16} />
            Saving changes...
          </span>
        )}
        <button
          type="button"
          className={styles.historyButton}
          onClick={onHistory}
          disabled={isPublishing}
        >
          History
        </button>
        <button
          type="button"
          className={`${styles.publishButton} ${
            isCreate || isPublishing
              ? styles.publishButtonGreen
              : styles.publishButtonDark
          }`}
          disabled={publishDisabled || isPublishing || isSaved}
          onClick={onPublish}
        >
          <span>{publishLabel}</span>
        </button>
      </div>
    </div>
  );
}

DisclosurePublishingBar.propTypes = {
  state: PropTypes.oneOf(Object.values(DisclosurePublishingState)).isRequired,
  isPublishing: PropTypes.bool,
  publishDisabled: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onHistory: PropTypes.func,
  onPublish: PropTypes.func.isRequired,
};

DisclosurePublishingBar.defaultProps = {
  isPublishing: false,
  publishDisabled: false,
  onHistory: () => {},
};

export default DisclosurePublishingBar;
